export const ELIGIBLE_COUNT_WARNING_THRESHOLD = 5000;

// GUID Mode
export const GUID_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
export const GUID_COUNT_DEBOUNCE_MS = 500;
export const GUID_TEXTAREA_PLACEHOLDER = `279c952f-7810-4a09-8927-7de5a1a0e3cf
7a8023ff-4725-4bad-8077-15c0f9132851
eo13f85f-8812-454e-aaea-15635bdb3fd5`;

export const BUTTON_SX = { mr: 0, marginTop: 0, borderRadius: 2 };
